import { createCrudSlice, createCrudSliceSelectors } from '@/store/util';

import {
  indexAccountUsers,
  editAccountUser,
  updateAccountUser,
} from './actions';

const options = {
  name: 'accountUsers',
  collectionName: 'users',
  recordName: 'user',
  actionsConfig: {
    index: {
      read: indexAccountUsers,
    },
    update: {
      read: editAccountUser,
      write: updateAccountUser,
    },
  },
};

const limitOptions = {
  name: 'accountUsers',
  collectionName: 'limit',
  recordName: 'limit',
  actionsConfig: {
    index: {
      read: indexAccountUsers,
    },
  },
};

export const { index: selectAccountUsers, update: selectAccountUserForUpdate } =
  createCrudSliceSelectors(options);
export const { index: selectAccountUserLimits } =
  createCrudSliceSelectors(limitOptions);

const { reducer } = createCrudSlice(options);
export default reducer;
